import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect, useMemo, useRef} from 'react';
import {connect} from 'react-redux';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import lodash from 'lodash';
//store functions
import {
  setSearchingMode,
  saveSelectedCountry,
  setConnectedToSelectedCountry,
  saveNotSupportedCountries,
  removeFromSelectedCountries,
  setSearchCountryResults,
  abroadCountriesSearched,
  setSelectedAbroadPackage,
  openModal,
  closeModal,
} from '../cellcomAbroadBlockSlice';
import {getDwhParams, dwhSetSelectedCountries} from './../dwhReports';
import EpiContext from '@episerver/spa-core/Spa';

import {popupReasonEnum, searchParametersEnum, lobbyTabsEnum} from '../cellcomAbroadVariables';
import {Container, Row, Col, Collapse, Button} from 'reactstrap';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import TextInput from '../../../Shared/TextInput/TextInput';
import CountryItemComponent from './CountryItemComponent';
import BtnRightSideText from '../../../Shared/Buttons/BtnRightSideText';
import SearchResultComponent from './SearchResultComponent';
import EmptySearchResultComponent from './EmptySearchResultComponent';
import LocalPopupContainer from '../LocalPopup/LocalPopupContainer';
import PopUp from '../../../Shared/Popup/PopUp';
import WarningMessagePopupContent from '../Popups/WarningMessagePopupContent';
import ConnectedCountryExistsPopupContent from '../Popups/ConnectedCountryExistsPopupContent';
import SelectedCountryIsNotSupportedInPackagePopupContent from '../Popups/SelectedCountryIsNotSupportedInPackagePopupContent';
import AllSelectedCountriseAreNotSupportedInPackagePopupContent from '../Popups/AllSelectedCountriesAreNotSupportedInPackagePopupContent';
import images from '../images/images';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {
  gaSelectCountriesTabIsClickedBusinessIndividual,
  gaSelectCountriesTabIsClicked,
  gaOnClosingSelectParametersTab,
  gaReportSelectingPopularCountry,
  gaSelectedCountriesList,
} from '../gaReports';
import fillIcon from '../images/fill/fill-1@3x.svg';
import clearIcon from '../images/clear/clear@3x.svg';

const SelectCountriesComponent = (props) => {
  const [searchValue, setSearchValue] = useState('');
  const [searching, setSearching] = useState(false);
  const ref = useRef();
  const isSeparatedSale = props.data.otpData.validatedCostumerData?.isSeparatedSale ? true : false;
  const startedFromPackage = props.data.startedFromPackage ? true : false;
  const isBusinessIndividual = props.data.epiStyleInitializationData.businessIndividualLobby ? true : false;

  //close popup from select dates item
  useEffect(() => {
    if (props.data.searchingMode.status && props.data.searchingMode.searchParameter == searchParametersEnum.DATES) {
      setSearchValue('');
      props.setSearchCountryResults([]);

      setSearching(false);
    } else if (
      props.data.searchingMode.status &&
      props.data.searchingMode.searchParameter == searchParametersEnum.COUNTRY &&
      props.data.popupReason == 'selectedDatesAreNotSuitableForSelectedPackage'
    ) {
      props.closeModal();
    }
  }, [props.data.searchingMode.status, props.data.searchingMode.searchParameter]);

  //searching mode
  useEffect(() => {
    if (searchValue && (props.data.statusRequest == 'completed' || props.data.searchCountryResults.length > 0)) {
      setSearching(true);
    } else {
      setSearching(false);
    }
  }, [searchValue, props.data.statusRequest]);

  //if connected to selected country exists
  useEffect(() => {
    if (props.data.connectedToSelectedCountry) {
      props.openModal(popupReasonEnum.CONNECTED_COUNTRY_EXISTS);
    }
  }, [props.data.connectedToSelectedCountry]);

  const currentPopup = useMemo(() => {
    if (
      props.data.isShowPopup &&
      props.data.searchingMode.status &&
      props.data.searchingMode.searchParameter == searchParametersEnum.COUNTRY &&
      props.data.popupReason != popupReasonEnum.OTP_RESULT
    ) {
      return getCurrentPopupContent();
    }
  }, [props.data.isShowPopup, props.data.searchingMode.status, props.data.popupReason]);

  //not supported countries (from package)
  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.data.notSupportedCountries?.length > 0 && props.data.selectedAbroadPackage) {
          if (props.data.notSupportedCountries?.length == props.data.selectedCountries?.length) {
            props.openModal(popupReasonEnum.ALL_SELECTED_COUNTRIES_ARE_NOT_SUPPORTED_IN_SELECTED_PACKAGE);
          } else {
            props.openModal(popupReasonEnum.SELECTED_COUNTRY_IS_NOT_SUPPORTED_IN_SELECTED_PACKAGE);
          }
        }
      }
    },
    [props.data.notSupportedCountries],
  );
  //DWH
  const [allowDWHReport, setAllowDWHReport] = useState(false);
  useEffect(() => {
    if (props.collapse) {
      setAllowDWHReport(true);
    } else {
      if (allowDWHReport && props.data.selectedCountries.length > 0) {
        const {channel, subscriber, param1, param4, param3, param5, param6, param7} = getDwhParams(props.data);
        dwhSetSelectedCountries({channel, subscriber, param1, param4, param3, param5, param6, param7});
        setAllowDWHReport(false);
      }
    }
  }, [props.collapse]);

  function getCurrentPopupContent() {
    let popup;
    switch (props.data.popupReason) {
      case popupReasonEnum.LIMIT_COUNTRIES_COUNT_ON_SELECT:
        const limitCountriesTitle = `אפשר לבחור  <span class="bold">עד חמישה יעדים</span> לחבילה`;
        const limitCountriesBtnText = 'אוקיי';
        popup = (
          <WarningMessagePopupContent
            title={limitCountriesTitle}
            btnText={limitCountriesBtnText}
            closeModal={() => closeModal()}
            activeLobbyTab={props.data.activeLobbyTab}
          />
        );
        break;
      case popupReasonEnum.COUNTRY_WARNING_INFO:
        const country = props.data.selectedCountries[props.data.selectedCountries.length - 1];
        const warningTitle = country.countryInfoPopup.infoPopupText;
        const icon = country.countryInfoPopup.infoPopupIcon;
        const warningBtnText = 'הבנתי, תודה';
        popup = (
          <WarningMessagePopupContent
            title={warningTitle}
            btnText={warningBtnText}
            icon={icon}
            closeModal={() => validateConnectedCountriesAndCloseModal()}
            activeLobbyTab={props.data.activeLobbyTab}
          />
        );
        break;
      case popupReasonEnum.CONNECTED_COUNTRY_EXISTS:
        popup = (
          <ConnectedCountryExistsPopupContent
            lastSelected={props.data.selectedCountries[props.data.selectedCountries.length - 1]}
            connectedCountry={props.data.connectedToSelectedCountry[0]}
            saveSelectedCountry={(connectedCountry) => saveSelectedCountry(connectedCountry)}
            setConnectedToSelectedCountry={(data) => props.setConnectedToSelectedCountry(data)}
            closeModal={() => closeModal()}
            activeLobbyTab={props.data.activeLobbyTab}
            startedFromPackage={props.data.startedFromPackage}
            isSeparatedSale={props.data.otpData.validatedCostumerData?.isSeparatedSale}
            isBusinessIndividual={isBusinessIndividual}
          />
        );
        break;
      case popupReasonEnum.SELECTED_COUNTRY_IS_NOT_SUPPORTED_IN_SELECTED_PACKAGE:
        popup = (
          <SelectedCountryIsNotSupportedInPackagePopupContent
            selectedCountries={props.data.selectedCountries}
            notSupportedCountries={props.data.notSupportedCountries}
            closeModal={() => closeModal()}
            saveNotSupportedCountries={() => props.saveNotSupportedCountries()}
            setSelectedAbroadPackage={(data) => props.setSelectedAbroadPackage(data)}
            getNextStep={() => getNextStep()}
            activeLobbyTab={props.data.activeLobbyTab}
            isSmallResolution={props.data.isSmallResolution}
            isSeparatedSale={props.data.otpData.validatedCostumerData?.isSeparatedSale}
          />
        );
        break;
      case popupReasonEnum.ALL_SELECTED_COUNTRIES_ARE_NOT_SUPPORTED_IN_SELECTED_PACKAGE:
        popup = (
          <AllSelectedCountriseAreNotSupportedInPackagePopupContent
            closeModal={() => closeModal()}
            getNextStep={(searchValue) => getNextStep(searchValue)}
            setSelectedAbroadPackage={() => props.setSelectedAbroadPackage(null)}
            saveNotSupportedCountries={() => props.saveNotSupportedCountries()}
            activeLobbyTab={props.data.activeLobbyTab}
            isSeparatedSale={props.data.otpData.validatedCostumerData?.isSeparatedSale}
          />
        );
        break;
    }
    return popup;
  }

  const clearSearchValue = (gaReport) => {
    if (gaReport && !props.data.epiStyleInitializationData.businessIndividualLobby) {
      switch (props.data.activeLobbyTab) {
        case lobbyTabsEnum.PRIVATE:
          if (props.data.startedFromPackage) {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_PRIVATE_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_PRIVATE_FROM_PACKAGE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_PRIVATE_FROM_PACKAGE.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_PRIVATE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_PRIVATE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_PRIVATE.eventParams,
            );
          }

          break;
        case lobbyTabsEnum.BUSINESSACCOUNT:
          if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_OPENDEVICETOHUL_CLICK.category,
              gaParams.SEPARATED_OPENDEVICETOHUL_CLICK.eventType,
              props.data.abroadPackagesList ? 'עמוד תוצאות חיפוש' : 'עמוד לובי',
            );
          } else {
            if (props.data.startedFromPackage) {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_BUSINESS_FROM_PACKAGE.category,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_BUSINESS_FROM_PACKAGE.eventType,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_BUSINESS_FROM_PACKAGE.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_BUSINESS.category,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_BUSINESS.eventType,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_REMOVE_SEARCH_VALUE_FROM_INPUT_BUSINESS.eventParams,
              );
            }
          }

          break;
        default:
          break;
      }
    }
    setSearchValue('');
    props.setSearchCountryResults([]);
  };

  const searchCountries = (value) => {
    setSearchValue(value);

    if (value.trim() && value) {
      props.abroadCountriesSearched(value);
    }
  };

  const checkIfSelectedAlready = (country) => {
    const ifExists = props.data.selectedCountries.some((item) => item.countryHebName === country.countryHebName);
    if (ifExists) {
      return true;
    }
    return false;
  };

  const saveSelectedCountry = (country) => {
    if (props.data.isShowPopup) {
      closeModal();
    }

    if (props.data.selectedCountries.length < 5) {
      if (!checkIfSelectedAlready(country)) {
        if (country.countryInfoPopup.countryLink) {
          EpiContext.navigateTo(country.countryInfoPopup.countryLink);
          return null;
        }
        props.saveSelectedCountry(country);
        validateIsShowCountryWarningMessage(country);
      }
    } else {
      props.openModal(popupReasonEnum.LIMIT_COUNTRIES_COUNT_ON_SELECT);
    }

    if (searchValue) {
      clearSearchValue(false);
    }
  };
  const validateIsShowCountryWarningMessage = (country) => {
    if (country.countryInfoPopup.isShowInfoPopup) {
      props.openModal(popupReasonEnum.COUNTRY_WARNING_INFO);
    } else {
      if (props.data.selectedCountries.length < 5) {
        validateAssociatedCountries(country);
      }
    }
  };
  const validateAssociatedCountries = (country) => {
    let unSelectedAssociatedCountries = null;
    let unSelectedAssociatedCountriesInSelectedPackage = null;

    if (country.associatedCountries?.length > 0 || country.linkToOtherCountry?.length > 0) {
      let associatedCountries = country.associatedCountries?.length > 0 ? country.associatedCountries : country.linkToOtherCountry;
      unSelectedAssociatedCountries = lodash.filter(associatedCountries, function (country) {
        if (!checkIfSelectedAlready(country)) {
          return country;
        }
      });
    }
    if (props.data.selectedAbroadPackage?.countrySupportedList?.length > 0) {
      unSelectedAssociatedCountriesInSelectedPackage = lodash.filter(unSelectedAssociatedCountries, function (country) {
        if (
          !checkIfSelectedAlready(country) &&
          props.data.selectedAbroadPackage.countrySupportedList?.some(
            (supportedCountry) => supportedCountry.countryCode.toLowerCase() === country.countryCode.toLowerCase(),
          )
        ) {
          return country;
        }
      });
    }

    if (
      unSelectedAssociatedCountries?.length > 0 &&
      (!props.data.selectedAbroadPackage ||
        (props.data.selectedAbroadPackage && unSelectedAssociatedCountriesInSelectedPackage?.length > 0))
    ) {
      props.setConnectedToSelectedCountry(unSelectedAssociatedCountries);
    }
  };

  //continue button event
  const validateAndContinue = () => {
    let listOfSelectedCountries = lodash.map(props.data.selectedCountries, 'countryHebName');
    gaSelectedCountriesList(props.data.activeLobbyTab, startedFromPackage, isSeparatedSale, listOfSelectedCountries, isBusinessIndividual);

    if (props.data.selectedAbroadPackage) {
      let unSupportedCountries = [];
      props.data.selectedCountries.map((selected) => {
        if (
          !props.data.selectedAbroadPackage.countrySupportedList?.some(
            (supportedCountry) => supportedCountry.countryCode.toLowerCase() === selected.countryCode.toLowerCase(),
          )
        ) {
          unSupportedCountries.push(selected);
        }
      });

      if (unSupportedCountries.length > 0) {
        props.saveNotSupportedCountries(unSupportedCountries);
        return false;
      }
    }
    //check if open next step
    getNextStep();
  };

  const getNextStep = (searchValue) => {
    if (!searchValue) {
      if (!props.data.dates.selectedStartDate || !props.data.dates.selectedEndDate) {
        props.setSearchingMode(searchParametersEnum.DATES);
      } else {
        if (props.data.selectedCountries?.length > 0) {
          props.setSearchingMode('');
          props.validateAndStartSearching();
        }
      }
    } else {
      props.setSearchingMode(searchValue);
    }
  };

  const closeModal = () => {
    if (props.data.popupReason == popupReasonEnum.CONNECTED_COUNTRY_EXISTS) {
      props.setConnectedToSelectedCountry('');
    } else if (props.data.popupReason == popupReasonEnum.COUNTRY_WARNING_INFO && props.data.selectedCountries.length < 5) {
      validateAssociatedCountries(props.data.selectedCountries[props.data.selectedCountries.length - 1]);
    }

    props.closeModal();
  };

  const validateConnectedCountriesAndCloseModal = () => {
    if (props.data.selectedCountries.length < 5) {
      validateAssociatedCountries(props.data.selectedCountries[props.data.selectedCountries.length - 1]);
    }
    props.closeModal();
  };

  const setSearchingMode = () => {
    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      gaSelectCountriesTabIsClickedBusinessIndividual();
    } else {
      gaSelectCountriesTabIsClicked(props.data.activeLobbyTab, props.data.otpData?.validatedCostumerData?.isSeparatedSale);
    }

    props.setSearchingMode(props.item.id);
    if (ref.current) {
      setImmediate(() => {
        ref.current?.focus();
      });
    }
  };

  const gaSelectFromPopularCountries = (country) => {
    const activeLobbyTab = props.data.activeLobbyTab;
    gaReportSelectingPopularCountry(activeLobbyTab, startedFromPackage, country, isSeparatedSale, isBusinessIndividual);
    saveSelectedCountry(country);
  };

  const gaAndCloseSearchingMode = () => {
    const parameterName = 'countries';
    gaOnClosingSelectParametersTab(isSeparatedSale, startedFromPackage, isBusinessIndividual, parameterName);
    props.setSearchingMode('');
  };
  
  var serchOrClearIcon = searchValue.trim() == '' ? fillIcon : clearIcon;

  return (
    <Col className={`${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12 p-0' : 'col-5'}`}>
      <div
        className={`bordered search-item-component ${props.collapse ? 'selecting-mode' : ''}`}
        onClick={() => (props.collapse ? null : setSearchingMode())}>
        <Container className={`search-item-component-wrapper ${props.selectedData ? 'selected-data-exists' : ''}`}>
          <Row>
            <Col className={`${props.collapse ? 'col-11 pl-0' : 'col-12'}`}>
              <span className='align-middle search-item-component-wrapper__icon'>
                <Image src={props.collapse ? props.item.activeIcon : props.item.icon} alt='icon' className='' />
              </span>
              <span
                className={`d-inline-block align-middle search-item-component-wrapper__title ${
                  props.collapse || props.selectedData ? 'data-exists' : ''
                }`}>
                {props.item.title}
              </span>
            </Col>

            {props.collapse && searchValue.trim() == '' && (
              <Col className={`${props.collapse ? 'col-1' : ''} pr-0`}>
                <span className={`align-middle search-item-component-wrapper__close`} onClick={() => gaAndCloseSearchingMode()}>
                  <Image src={images.close} alt='icon' />
                </span>
              </Col>
            )}
          </Row>

          {!props.collapse && props.selectedData && (
            <Row>
              <Col>
                <span
                  className='align-middle bold search-item-component-wrapper__selected-data'
                  dangerouslySetInnerHTML={{__html: props.selectedData}}
                />
              </Col>
            </Row>
          )}

          <Collapse isOpen={props.collapse}>
            <Row>
              <Col className='search-item-component-wrapper__search-form'>
                <TextInput
                  ref={ref}
                  value={searchValue}
                  name='search'
                  type='text'
                  placeholder='שם היעד'
                  onChange={(e) => searchCountries(e.target.value)}
                  autoComplete='off'
                />
                <Button
                  color='link'
                  className={`${searchValue.trim() == '' ? 'search' : 'clear'} search-form-icon`}
                  style={{backgroundImage: serchOrClearIcon.bg()}}
                  onClick={() => clearSearchValue(true)}
                />
              </Col>
            </Row>
          </Collapse>
          {!searching ? (
            <>
              <Row>
                <Col>
                  <span className='search-item-component-wrapper__description'>
                    {props.selectedCountriesList?.length > 0 && !props.collapse
                      ? props.selectedCountriesList?.length == 1
                        ? null
                        : props.selectedCountriesList.map((country, index) => {
                            return (
                              <span className='ml-1' key={index}>
                                <bdi>{country.countryHebName}</bdi>
                                {index < props.selectedCountriesList.length - 1 ? ',' : ''}
                              </span>
                            );
                          })
                      : props.item.description}
                  </span>
                </Col>
              </Row>
              <Row>
                <Collapse isOpen={props.collapse} className='w-100 col'>
                  <Col className='search-wrapper'>
                    <Row>
                      <Col className='selected-countries-list'>
                        {props.data.selectedCountries.map((country, index) => {
                          return (
                            <CountryItemComponent
                              key={index}
                              country={country}
                              selected={true}
                              action={(country) => props.removeFromSelectedCountries(country)}
                            />
                          );
                        })}
                      </Col>
                    </Row>
                    <Row>
                      <Col className='p-0'>
                        <span
                          className={`bold font-16 ${
                            isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'pt-3 pb-2 d-block' : ''
                          }`}>
                          יעדים פופולריים
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col className='popular-countries-list'>
                        {props.data.popularCountries.map((country, index) => {
                          if (!checkIfSelectedAlready(country)) {
                            return (
                              <CountryItemComponent
                                key={index}
                                country={country}
                                selected={false}
                                action={(country) => gaSelectFromPopularCountries(country)}
                              />
                            );
                          }
                        })}
                      </Col>
                    </Row>
                    <Row>
                      <Col className='p-0'>
                        <BtnRightSideText
                          onclick={() => validateAndContinue()}
                          isDisplayArrows={true}
                          text={'המשך'}
                          customClass='search-item-button'
                        />
                      </Col>
                    </Row>
                  </Col>
                </Collapse>
              </Row>
            </>
          ) : (
            <>
              {props.data.searchCountryResults.length > 0 ? (
                <div className='search-result-wrapper'>
                  {props.data.searchCountryResults.map((country, index) => {
                    return (
                      <SearchResultComponent
                        key={index}
                        country={country}
                        saveSelectedCountry={saveSelectedCountry}
                        activeLobbyTab={props.data.activeLobbyTab}
                        startedFromPackage={props.data.startedFromPackage}
                        isSeparatedSale={props.data.otpData.validatedCostumerData?.isSeparatedSale}
                        isBusinessIndividual={isBusinessIndividual}
                      />
                    );
                  })}
                </div>
              ) : (
                <Row>
                  <EmptySearchResultComponent
                    searchValue={searchValue}
                    activeLobbyTab={props.data.activeLobbyTab}
                    startedFromPackage={props.data.startedFromPackage}
                    isSeparatedSale={props.data.otpData.validatedCostumerData?.isSeparatedSale}
                    isBusinessIndividual={isBusinessIndividual}
                  />
                </Row>
              )}
            </>
          )}
          {isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? (
            <PopUp
              className={props.data.popupReason}
              showPopUp={
                props.data.isShowPopup &&
                props.data.searchingMode.status &&
                props.data.searchingMode.searchParameter == searchParametersEnum.COUNTRY &&
                props.data.popupReason != popupReasonEnum.OTP_RESULT
              }
              onClose={() => closeModal()}>
              {currentPopup}
            </PopUp>
          ) : (
            <LocalPopupContainer
              className={props.data.popupReason}
              showPopUp={
                props.data.isShowPopup &&
                props.data.searchingMode.status &&
                props.data.searchingMode.searchParameter == searchParametersEnum.COUNTRY &&
                props.data.popupReason != popupReasonEnum.OTP_RESULT
              }
              onClose={() => closeModal()}>
              {currentPopup}
            </LocalPopupContainer>
          )}
        </Container>
      </div>
    </Col>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
  };
};

const mapDispatchToProps = {
  setSearchingMode,
  saveSelectedCountry,
  setConnectedToSelectedCountry,
  saveNotSupportedCountries,
  removeFromSelectedCountries,
  setSearchCountryResults,
  abroadCountriesSearched,
  setSelectedAbroadPackage,
  openModal,
  closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectCountriesComponent);
